export default __webpack_public_path__ + "static/media/Icon_Account.13e97818.svg";